export default __webpack_public_path__ + "static/media/pic5.a572e63f.jpg";